namespace GameLogger {
  export enum LogLevel {
    DEBUG,
    INFO,
    WARN,
    ERROR,
    NONE
  }

  let currentLogLevel = process.env.NODE_ENV === "production" ? LogLevel.ERROR : LogLevel.INFO;

  export function setLogLevel(level: LogLevel) {
    currentLogLevel = level;
  }

  export function logDebug(context: string, ...args: any[]) {
    if (currentLogLevel <= LogLevel.DEBUG) {
      console.debug(`[DEBUG][${context}]`, ...args);
    }
  }

  export function logInfo(context: string, ...args: any[]) {
    if (currentLogLevel <= LogLevel.INFO) {
      console.info(`[INFO][${context}]`, ...args);
    }
  }

  export function logWarn(context: string, ...args: any[]) {
    if (currentLogLevel <= LogLevel.WARN) {
      console.warn(`[WARN][${context}]`, ...args);
    }
  }

  export function logError(context: string, ...args: any[]) {
    if (currentLogLevel <= LogLevel.ERROR) {
      console.error(`[ERROR][${context}]`, ...args);
    }
  }
}

export { GameLogger };
